import { type ReactNode, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { COPY } from '../copy';

interface StatusScreenProps {
  title: string;
  body: string;
  reference?: string | undefined;
  actions: ReactNode;
}

/** Full-page blocking state: the heading takes focus on mount (A11Y-010). */
export function StatusScreen({ title, body, reference, actions }: StatusScreenProps) {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <Container component="main" maxWidth="sm" sx={{ py: 8 }}>
      <Box role="alert">
        <Typography variant="h1" component="h1" tabIndex={-1} ref={headingRef} gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {body}
        </Typography>
        {reference !== undefined && (
          <Typography variant="caption" component="p" color="text.secondary" sx={{ mb: 3 }}>
            {COPY.reference(reference)}
          </Typography>
        )}
        <Stack direction="row" spacing={2}>
          {actions}
        </Stack>
      </Box>
    </Container>
  );
}
